var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.72 21.64C17.8 21.56 17.858 21.46 17.9 21.358C18.1 20.98 18.038 20.498 17.72 20.178L10.48 12.94L17.64 5.78C18.06 5.36 18.06 4.722 17.64 4.302C17.44 4.1 17.18 4 16.92 4H6C3.8 4 2 5.8 2 8V26C2 28.2 3.8 30 6 30H9.02C9.302 30 9.562 29.9 9.76 29.7L11.44 28L17.642 21.76C17.68 21.72 17.68 21.68 17.72 21.64ZM8.5 28H6C4.9 28 4 27.1 4 26V8C4 6.9 4.9 6 6 6H14.48L8.28 12.18C7.96 12.5 7.9 12.98 8.1 13.36C8.14 13.46 8.2 13.56 8.28 13.64C8.32 13.68 8.32 13.72 8.36 13.76L15.54 20.94L8.5 28ZM26 4H22.92C22.64 4 22.378 4.1 22.18 4.3L20.48 6L14.28 12.18C13.764 12.742 13.86 13.228 14.36 13.76L21.54 20.94L14.28 28.22C13.88 28.62 13.88 29.278 14.28 29.698C14.48 29.9 14.76 30 15.02 30H26C28.2 30 30 28.2 30 26V8C30 5.8 28.2 4 26 4ZM28 26C28 27.1 27.1 28 26 28H17.44L23.642 21.76C24.118 21.296 24.102 20.592 23.722 20.18L16.48 12.94L23.42 6H26C27.1 6 28 6.9 28 8V26Z",
    fill: "#DCDEDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFail);
export default __webpack_public_path__ + "static/media/img-fail.6284cada66394028f2f679055a4add51.svg";
export { ForwardRef as ReactComponent };